// Documento: Como conectar Facebook / Messenger
// Categoría: Facebook
// Última actualización: 2024-12-28

const document = {
  "id": "conectar-facebook-messenger",
  "title": "Como conectar Facebook / Messenger",
  "category": "Facebook",
  "description": "Guía paso a paso para conectar tu cuenta de Facebook/Messenger a Runamatic. Aprende a configurar correctamente los permisos y ajustes necesarios.",
  "explanations": [
    {
      "title": "Requisitos previos",
      "content": "Solo se pueden automatizar cuentas de Instagram / Facebook de tipo Empresa y Creador. Para poder conectar su cuenta a nuestra plataforma es necesario estar logeado con un perfil administrador de la cuenta a conectar en la misma sesión del explorador de internet."
    }
  ],
  "steps": [
    {
      "title": "Iniciar la conexión desde Runamatic",
      "content": "Desde el menú principal de nuestra aplicación debe ir a Ajustes > Canales. Seleccione Facebook Messenger > Conectar. Siga adelante con las instrucciones.",
      "images": [
        "https://drive.google.com/thumbnail?id=1LH5RrXsdeYkvJwdQPze9JyiwFjI0FdMQ&sz=w1000"
      ]
    },
    {
      "title": "Acceder a la configuración de Facebook",
      "content": "En otra pestaña del explorador diríjase a la página de su cuenta de empresa de Facebook. Seleccione el perfil de la cuenta empresa y vaya a Configuración y Privacidad > Configuración > Configuración de la página.",
      "images": [
        "https://drive.google.com/thumbnail?id=1hmLQJsAaBnd1zI2reVY5nO0z2AF4IHT7&sz=w1000"
      ]
    },
    {
      "title": "Configurar Mensajería Avanzada",
      "content": "En la configuración de la página, seleccione Mensajería Avanzada > Ver.",
      "images": [
        "https://drive.google.com/thumbnail?id=1PEAI7TdGUun_RKAp1M530UkLGB_j48f_&sz=w1000"
      ]
    },
    {
      "title": "Configurar Mensajería Avanzada",
      "content": "Asegúrese de que tanto el Receptor de Messenger como el Receptor de Instagram tengan seleccionado Appcontx.",
      "images": [
        "https://drive.google.com/thumbnail?id=1oBWVILN_e5q_pg4eHW1GSW1R5c395mV3&sz=w1000"
      ]
    },
    {
      "title": "Configurar permisos en cuenta personal",
      "content": "Para evitar problemas de permisos, acceda a la cuenta personal de Facebook que controla el portfolio comercial. Vaya a Configuración y Privacidad > Configuración y haga click en Integraciones comerciales.",
      "images": [
        "https://drive.google.com/thumbnail?id=14GL4VXKRsk195Dkhc00Ip0KJQRI1Sfw0&sz=w1000"
      ]
    },
    {
      "title": "Otorgar permisos a Appcontx",
      "content": "Haga click en Ver y editar sobre la aplicación Appcontx. Dele todos los permisos que estén listados y haga click en Guardar para completar la configuración.",
      "images": [
        "https://drive.google.com/thumbnail?id=1pD0qakQWjF8ytrAu8PobqpVL9bD4Q9Xk&sz=w1000"
      ]
    }
  ],
  "tags": [
    "facebook",
    "messenger",
    "conexión",
    "configuración",
    "permisos"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
